import ReactDOM from 'react-dom/client';
import App from './App';
//clickjacking prevention
if (window.top !== window.self && window.top) {
  window.top.location.href = window.self.location.href;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(<App />);
